import { Controller, useFormContext } from "react-hook-form";
import { SetupNative2faFormValues } from "../../types";
import { mfaStrategyInfoMap } from "../../constants";
import { Stack, View, Text, TextField } from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../../../utilities/i18n";

export const EnterMfaIdentifierFieldset = () => {
  const { t } = useTranslation("settings");
  const formContext = useFormContext<SetupNative2faFormValues>();
  const { control, register, watch, formState } = formContext;
  const { errors, isValid, isDirty, isSubmitting } = formState;
  const isDisabled = !isValid || !isDirty || isSubmitting;

  const strategy = watch("data.strategy");
  const strategyData = mfaStrategyInfoMap[strategy];

  return (
    <View>
      <Stack vertical>
        <View>
          <Text>{t("form.native_2fa_identifier.label")}</Text>
          <Text>{strategyData?.identifierInputDescription}.</Text>
        </View>
        <View>
          <Controller
            name="data.identifier"
            control={control}
            render={({ field: { onChange, value } }) => {
              return (
                <TextField
                  validationMessage={errors?.data?.identifier?.message}
                  value={value}
                  onChangeText={onChange}
                />
              );
            }}
          />
        </View>
        {errors.root?.serverError &&
          errors.root.serverError.message !== `MFA_REQUIRED_ERROR` && (
            <Text color="destructive">{errors.root.serverError.message}</Text>
          )}
      </Stack>
    </View>
  );
};
